module.exports = "<p>\n  widget works!\n</p>\n"